import { render, staticRenderFns } from "./StripeBindCardPay.vue?vue&type=template&id=6fc009ad&scoped=true"
import script from "./StripeBindCardPay.vue?vue&type=script&lang=js"
export * from "./StripeBindCardPay.vue?vue&type=script&lang=js"
import style0 from "./StripeBindCardPay.vue?vue&type=style&index=0&id=6fc009ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc009ad",
  null
  
)

export default component.exports